import React from 'react'
import Tile from '../presentation/Tile.js'
import Cta from '../presentation/Cta.js'

class TileLayout extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ctaFade: false,
      ctaActive: false,
      ctaPosition: {},
    }

  }

  displayCta(e) {
    e.preventDefault()

    clearTimeout(this.state.fadeOutTimer)
    this.setState({
      ctaActive: true,
      ctaPosition: {x: e.clientX, y: e.clientY + window.pageYOffset - 200}
    })
    setTimeout(this.activateCta.bind(this), 0)
  }

  activateCta() {
    this.setState({
      ctaFade: true,
      fadeOutTimer: setTimeout(this.fadeOutCta.bind(this), 2500)
    })
  }

  fadeOutCta() {
    this.setState({
      ctaFade: false
    })
    setTimeout(this.deactivateCta.bind(this), 500)
  }

  deactivateCta() {
    this.setState({
      ctaActive: false
    })
  }

  displayTiles(servicesToCompare) {
    let tiles = servicesToCompare.map((i, index) => (
          <Tile key={i.id}
               values={i}
               filterKey={this.props.filterKey}
               handleRemoveItem={this.props.handleRemoveItem}
               fields={this.props.fields}
               tileFieldCount={this.props.tileFieldCount}
               accessLevel={this.props.accessLevel}
               directoryFreeExplanationPartialTile={this.props.directoryFreeExplanationPartialTile}
               lockedTileCta={this.props.lockedTileCta}
               index={index}
               freeAccess={this.props.freeAccess}
               displayCta={this.displayCta.bind(this)}
               {...this.props} />
      )
    );

    if (this.props.accessLevel == 'bronze' || this.props.freeAccess == true && this.props.hasFreeAccessCta) {
      tiles.splice(tiles.length ? 1 : 0, 0,
          <Tile key={'donate-cta'}
            isDonateCTA
            filterKey={this.props.filterKey}
            handleRemoveItem={this.props.handleRemoveItem}
            fields={this.props.fields}
            tileFieldCount={this.props.tileFieldCount}
            accessLevel={this.props.accessLevel}
            directoryFreeExplanationPartialTile={this.props.directoryFreeExplanationPartialTile}
            lockedTileCta={this.props.lockedTileCta}
            freeAccess={this.props.freeAccess}
            displayCta={this.displayCta.bind(this)}
            {...this.props} />
      );
    }
    return tiles;
  }

  render() {
    let servicesToCompare = this.props.servicesToCompare;

    return (
      <section className="pb4 tile-layout w-100 flex">
        <Cta
          fade={this.state.ctaFade}
          active={this.state.ctaActive}
          xPosition={this.state.ctaPosition.x}
          yPosition={this.state.ctaPosition.y}
          lowestMonthlyPrice={this.props.lowestMonthlyPrice}
        />
        <div className='w-100 flex flex-wrap'>
          {this.displayTiles(servicesToCompare)}
        </div>
      </section>
      )
  }
}

export default TileLayout;
